import React, { Fragment, useState, useEffect } from "react";
import Header from "../common/header";
import Footer from "../common/footer";
import BlogInnerBanner from "./blog-inner-banner";

import BlogDiscription from "./blog-inner-descriptions";
import LatestInnerBlog from "./latest-inner-blog";

import { useParams } from "react-router-dom";

import * as apiUrl from "../../apiUrl";

import logo from "../../assets/marquis-logo.svg";

function BlogInnerPage() {
  
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await fetch( apiUrl.apiUrl + `/api/blogs/blog-inner-page/${slug}`);
        if (!response.ok) {
          throw new Error("Blog not found");
        }
        const data = await response.json();
        setBlog(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching blog:", error);
        setLoading(false);
      }
    };

    fetchBlog();
  }, [slug]);

  if (loading) {
    return (
      <div className="loading-container">
        <img src={logo} alt="Loading" className="loading-logo" />
      </div>
    );
  }

  if (!blog) {
    return <p>Blog not found.</p>;
  }

  return (
    <Fragment>
      <Header />
      <BlogInnerBanner
        bannerImage={blog.banner_image}
        title={blog.blog_title}
        description={blog.description}
      />
      <BlogDiscription
        description={blog.description}
        postingDate={blog.posting_date}
        place={blog.place}
        title={blog.blog_title}
        centerImage={blog.center_image}
      />
      <LatestInnerBlog />
      <Footer />
    </Fragment>
  );
}
export default BlogInnerPage;
